import execDelay from './execDelay';

function makeGlitch(bgAnimation, textAnimation){
    textAnimation.current.style.display = "none";


    for(let i = 0 ; i < 20 ; i++) {
        let divEl = document.createElement("div");
        divEl.style.width = Math.round(Math.random() * 40) + "vw";
        divEl.style.height = Math.round(Math.random() * 10) + "vh";
        divEl.className = "glitchEls";
        divEl.style.position = "relative";
        bgAnimation.current.appendChild(divEl)
    }

        const cInt = setInterval(() => {
            const els = document.querySelectorAll(".glitchEls");
            for(let i = 0 ; i < els.length ; i++) {
                els[i].style.top = Math.round(Math.random() * 100) + "px";
                els[i].style.left = Math.round(Math.random() * 100) + "vw";

                els[i].style.backgroundPositionX = Math.floor(Math.random() * 20 ) + "px";
                els[i].style.backgroundPositionY = Math.floor(Math.random() * 20 ) + "px";
            }
        }, 200);
        // mostra il testo dopo il glitch
        setTimeout(() => {
            clearInterval(cInt)
            const els = document.querySelectorAll(".glitchEls");
            for(let i = 0 ; i < els.length ; i++) {
                els[i].classList.remove("glitchEls")
            }
            textAnimation.current.style.display  = "block";
            textAnimation.current.style.className = "textBgAni";
        }, 3000);

        setTimeout(() => {
            textAnimation.current.style.display  = "none";
            textAnimation.current.style.opacity  = 1;
            textAnimation.current.style.lecterSpacing  = 100;
        }, 7000 );
textAnimation.current.innerHTML = '';
execDelay(textAnimation);
}


export default makeGlitch;